import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const BeneficiaryIcon = (props) => {
    return (
        <SvgIcon {...props} width="16" height="20" viewBox="0 0 16 20">
          <g id="Group_4778" data-name="Group 4778" transform="translate(-27 -191)">
            <path id="Path_1411" data-name="Path 1411" d="M450,535v12h2V535Zm-1,13H439v2h10Zm-11-1V535h-2v12Zm1-13h2v-2h-2Zm8,0h2v-2h-2Zm-8,14a1,1,0,0,1-1-1h-2a3,3,0,0,0,3,3Zm11-1a1,1,0,0,1-1,1v2a3,3,0,0,0,3-3Zm2-12a3,3,0,0,0-3-3v2a1,1,0,0,1,1,1Zm-14,0a1,1,0,0,1,1-1v-2a3,3,0,0,0-3,3Zm5-3h2v-2h-2Zm2,2h-2v2h2Zm-2,0a1,1,0,0,1-1-1h-2a3,3,0,0,0,3,3Zm3-1a1,1,0,0,1-1,1v2a3,3,0,0,0,3-3Zm-1-1a1,1,0,0,1,1,1h2a3,3,0,0,0-3-3Zm-2-2a3,3,0,0,0-3,3h2a1,1,0,0,1,1-1Z" transform="translate(-409 -339)" fill="#0a3256"/>
            <path id="Path_1412" data-name="Path 1412" d="M198.356,295h2.685m0,0v3.559m0-3.559-2.685,3.559-1.342-1.779L195,299.449" transform="matrix(0.985, -0.174, 0.174, 0.985, -211.624, -55.926)" fill="none" stroke="#0a3256" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          </g>
        </SvgIcon>
    );
};

export default BeneficiaryIcon;
